<h3>Login</h3>

@if (!loginDisplay) {
  <button mat-raised-button (click)="login()">Login</button>
}
@if (loginDisplay) {
  <button mat-raised-button color="accent" (click)="logout()">Logout</button>
}

@if (loginDisplay) {
  <p class="text-left">
    See below the claims in your <strong> ID token </strong>. For more information, visit:
    <span>
      <a href="https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token">
        docs.microsoft.com
      </a>
    </span>
  </p>
}

<div>
  @if (dataSource) {
    <table class='table table-striped table-bordered' aria-labelledby="tableLabel">
      <thead>
        <tr>
          <th>Claim</th>
          <th>Value</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (ds of dataSource; track ds) {
          <tr>
            <td>{{ ds.claim }}</td>
            <td>{{ ds.value }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>